import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "antd";
import { useI18n } from "../../../../../contexts";
const FormContentBlockerFieldTechnicalServices = (param)=>{
    let { dropdown, children } = param;
    const { __, _i } = useI18n();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.criteria !== nextValues.criteria,
        children: (param)=>{
            let { getFieldValue } = param;
            const criteria = getFieldValue("criteria");
            return criteria === "services" && /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Connected services"),
                required: true,
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "services",
                        noStyle: true,
                        rules: [
                            {
                                type: "array",
                                required: true,
                                message: __("Please provide at least one service!")
                            }
                        ],
                        children: dropdown
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: _i(__("A content blocker is displayed until the user has agreed to {{strong}}all{{/strong}} necessary services that would be used by loading the content. You must define all services that are loaded as soon as the user wants to see the blocked content."), {
                            strong: /*#__PURE__*/ _jsx("strong", {})
                        })
                    }),
                    children
                ]
            });
        }
    });
};
export { FormContentBlockerFieldTechnicalServices };
